import React, { FC } from 'react';
import { FormProvider } from 'react-hook-form';

import { fc } from 'i18n';
import Controls from './controls';
import { EntryPassMap } from './map';
import { TableFooter } from './footer';
import { TepIntents } from 'constants/tep';
import { EditModal } from './modals/edit-modal';
import { DraftModal } from './modals/draft-modal';
import { IssueModal } from './modals/issue-modal';
import { ErrorModal } from './modals/error-modal';
import { ReturnModal } from './modals/return-modal';
import { UndraftModal } from './modals/undraft-modal';
import { OfficersModal } from './modals/officers-modals';
import { StickyTable } from 'components/organisms/sticky-table';
import { NotifyOfficersModal } from './modals/notify-officers-modal';
import { useTepLeasesTable } from 'hooks/tep/leases/useTepLeasesTable';

import styles from './styles.module.css';

export const TepManagement: FC = () => {
  const { marker, formMethods, intent, controlProps, tableProps, footerProps } = useTepLeasesTable();

  return (
    <div className={styles.wrapper} style={{ height: `${window.innerHeight - 70}px` }}>
      <div className={styles.card}>
        <div className={styles.header}>{fc('TEP management')}</div>
        <Controls {...controlProps} />
        <div style={{ display: 'flex' }}>
          <div>
            <FormProvider {...formMethods}>
              <StickyTable {...tableProps} />
            </FormProvider>
          </div>
          {!!marker && <EntryPassMap offset={tableProps.offset} uri={marker?.uri} />}
        </div>
        {!!tableProps.data?.length && <TableFooter {...footerProps} />}
      </div>
      {intent === TepIntents.Edit && <EditModal />}
      {intent === TepIntents.Draft && <DraftModal />}
      {intent === TepIntents.Issue && <IssueModal />}
      {intent === TepIntents.Undraft && <UndraftModal />}
      {intent === TepIntents.Return && <ReturnModal />}
      {intent === TepIntents.Notify && <NotifyOfficersModal />}
      {intent === TepIntents.ManageOfficers && <OfficersModal />}
      <ErrorModal />
    </div>
  );
};
